import React from "react";
import styles from "./card-header.module.scss";
import { flag, passport } from "../../../utilities/utils";

const CardHeader = ({
  countryCode,
  countryName,
  visaFreeDestinations,
  showPassport,
  showCBI,
  showCBN,
  showRBI,
}) => {
  const documentIcon = () => {
    if (showPassport) {
      return (
        <div className={styles.passport}>
          <img src={passport(countryCode)} alt={countryName} />
        </div>
      );
    }
    if (showCBI || showCBN) {
      return (
        <div className={styles.rcbiIcon}>
          <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="CBI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="Group" transform="translate(6.000000, 0.000000)" stroke="#000000">
                      <rect id="Rectangle" x="0.5" y="0.5" width="27" height="39" rx="2"></rect>
                      <circle id="Oval" cx="14.5" cy="16.5" r="9"></circle>
                      <line x1="6.5" y1="31.5" x2="22.5" y2="31.5" id="Line"></line>
                      <line x1="5.5" y1="16.5" x2="23.5" y2="16.5" id="Line-Copy"></line>
                      <path d="M13.5,7.5 C11.5200857,9.85895284 10.5301285,12.8589528 10.5301285,16.5 C10.5301285,20.1410472 11.5200857,23.1410472 13.5,25.5" id="Line-2"></path>
                      <path d="M18.5,7.5 C16.5200857,9.85895284 15.5301285,12.8589528 15.5301285,16.5 C15.5301285,20.1410472 16.5200857,23.1410472 18.5,25.5" id="Line-2-Copy" transform="translate(17.015064, 16.500000) scale(-1, 1) translate(-17.015064, -16.500000) "></path>
                      <path d="M16,15 C14.0200857,16.7036882 13.0301285,18.8703548 13.0301285,21.5 C13.0301285,24.1296452 14.0200857,26.2963118 16,28" id="Line-2-Copy-2" transform="translate(14.515064, 21.500000) rotate(90.000000) translate(-14.515064, -21.500000) "></path>
                      <path d="M16,6 C14.0200857,7.70368816 13.0301285,9.87035483 13.0301285,12.5 C13.0301285,15.1296452 14.0200857,17.2963118 16,19" id="Line-2-Copy-3" transform="translate(14.515064, 12.500000) scale(1, -1) rotate(90.000000) translate(-14.515064, -12.500000) "></path>
                  </g>
              </g>
          </svg>
        </div>
      );
    }

    if (showRBI) {
      return (
        <div className={styles.rcbiIcon}>
          <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="RBI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="icon" transform="translate(0.000000, 6.000000)" stroke="#000000">
                      <rect id="Rectangle" transform="translate(20.000000, 14.000000) rotate(90.000000) translate(-20.000000, -14.000000) " x="6.5" y="-5.5" width="27" height="39" rx="2"></rect>
                      <circle id="Oval" cx="13" cy="11" r="4.5"></circle>
                      <path d="M7.5,20.5 C7.5,17.5 9.33333333,16 13,16 C16.6666667,16 18.5,17.5 18.5,20.5" id="Line"></path>
                      <line x1="24.5" y1="9.5" x2="33.5" y2="9.5" id="Line-3" strokeLinecap="square"></line>
                      <line x1="24.5" y1="13.5" x2="33.5" y2="13.5" id="Line-3-Copy" strokeLinecap="square"></line>
                      <line x1="24.5" y1="17.5" x2="29" y2="17.5" id="Line-3-Copy-2" strokeLinecap="square"></line>
                  </g>
              </g>
          </svg>
        </div>
      );
    }
  };

  return (
    <div className={styles.cardHeader}>
      <div className="row justify-content-between align-items-end">
        <div className="col">
          <div className={styles.cardHeaderTopLeft}>
            <div className={styles.flag}>
              <img src={flag(countryCode)} alt={countryName} />
            </div>
            <h3 className={`mb-0 ${!showPassport ? styles.heading : ""}`}>
              {countryName}
              {/* {showCBI ? <small>(CBI)</small> : ""}
              {showCBN ? <small>(CBN)</small> : ""} */}
              {showRBI ? " Residence" : ""}
            </h3>
          </div>
          {documentIcon()}
        </div>
        {/* <div className="col-auto">{documentIcon()}</div> */}
      </div>
      <div className={`row justify-content-between align-items-end ${styles.visaFreeRow}`}>
        <div className="col">
          <strong>No. of Visa-Free Destinations</strong>
        </div>
        <div className="col-auto">
          <strong>{visaFreeDestinations}</strong>
        </div>
      </div>
    </div>
  );
};

export default CardHeader;
